const styles = {
  searchGrid: {
    margin: '0 auto !important',
    width: '100% !important',
  },
  container: {
    borderRadius: '.42857em !important',
  },
  '@global .ui.card': {
    boxShadow:
      '0 .0625em 0 0 rgba(0,0,0,0.03), 0 .125em .375em 0 rgba(0,0,0,0.06); !important',
  },
  content: {
    display: 'flex !important',
  },
  button: {
    backgroundColor: '#8F3DE6 !important',
    color: '#fff !important',
    borderRadius: '.14285em !important',
    opacity: 1,
    padding: '.85714rem 1.5rem .85714rem !important',
  },
};

export default styles;
